import {Component} from '@angular/core';
import {ApiService} from '../../../utils/services/api.service';
import {AppService} from '../../../utils/services/app.service';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-masterkey',
  templateUrl: './masterkey.component.html',
  styleUrls: ['./masterkey.component.css']
})
export class MasterkeyComponent {
  public generatedKey: string = '';
  public isLoading: boolean = false;
  public userId: number;

  constructor(public appService: AppService, private apiService: ApiService, private notifications: NotificationsService,) {
  }

  generateNewMasterKey() {
    this.isLoading = true;
    this.generatedKey = '';
    this.userId = this.appService.getAuthUser().id;
    this.apiService.generateMasterKey(this.userId).subscribe(res => {
      this.generatedKey = res.data;
      this.isLoading = false;
    }, err => {
      console.error('Masterkey üretim hatası:', err);
      this.isLoading = false;
      alert('Anahtar üretilemedi. Lütfen tekrar deneyin.');
    });
  }

  copyToClipboard() {
    if (this.generatedKey) {
      (navigator as any).clipboard.writeText(this.generatedKey);
      this.notifications.success('Kopyalandı');
    }
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/masterkey/masterkey.component.ts